module.exports = __webpack_public_path__ + "static/unh.4bab327b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/unh.png
// module id = 2207
// module chunks = 61762850755587